import i18n from '@casops/i18n';
import { EmptyCell, GenericValueFormatterFunc } from './genericFormatters';
import { isEnumValue } from '@cas/utils/typeHelpers';
import { ConfigPackageFileType } from '@casops/store/apis/configurationGroupsApi';
import { AssetDeviceType } from '@casops/store/apis/registeredAssetsApi';

export const ConfigPackageFileTypeFormatter: GenericValueFormatterFunc<ConfigPackageFileType> = ({
  value,
}) => {
  return typeof value === 'string' && isEnumValue(value, ConfigPackageFileType)
    ? i18n.t(`ConfigPackageFileType.${value}`)
    : EmptyCell;
};

export const AssetDeviceTypeFormatter: GenericValueFormatterFunc<AssetDeviceType> = ({ value }) => {
  return typeof value === 'string' && isEnumValue(value, AssetDeviceType)
    ? i18n.t(`AssetDeviceType.${value}`)
    : EmptyCell;
};
